import React from 'react';

import { getRecords } from 'models/records';

import { CustomRoute } from 'util/hook/useRouter';

const routes: CustomRoute = {
	path: '/records',
	components: () => [import(/* webpackChunkName: 'records' */ './component')],
	render: ([Records]) => <Records />,
	onEnter: async ({ store, history }) => {
		console.log('on Enter member');

		const { login } = store.getState();
		const [isExpired, isNotGrMember] = [login.isGrMember.expired, !login.isGrMember.isMember];
		// console.log(isExpired, 'isExpired');
		// console.log(isNotGrMember, 'isNotGrMember');

		// token 過期 or 非會員 皆無法進入會員頁
		if (isExpired || isNotGrMember) {
			history.replace('/');
		}

		await store.dispatch(getRecords());
		console.log('on Enter member / end');
	},
};

export default routes;
